// extracted by mini-css-extract-plugin
export default {"root":"Payments_root__QMG+2"};